

exports.__esModule = true;

var _angular = require('angular');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _uiRouter = require('uiRouter');

var _integration = require('js/lib/integration');

var _index = require('xo-models/src/auth/index');

var _index2 = require('xo-models/src/checkout/index');

var _index3 = require('xo-device-info/dist/index');

var _fn = require('xo-login-components/src/login/fn');

require('xo-ui-components/src/spinner/directive');

require('xo-page-components/src/merchant-header/directive');

require('xo-page-components/src/header/directive');

require('xo-page-components/src/footer/directive');

require('xo-page-components/src/cart/directive');

require('xo-ui-components/src/directionality/directive');

require('xo-ui-components/src/error-tooltip/directive');

require('xo-validation/dist/directive');

require('xo-login-components/src/login-overlay/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCheckoutComponent', {

    tag: 'xo-checkout',
    template: _template2['default'],

    resolve: {
        pxp: function pxp() {
            var pxp = _squid.$config.purchaseProtectionProp.pxp;

            return {
                purchaseProtectionAlt: (0, _squid.$pxp)(pxp.pgName, pxp.patterns)
            };
        },
        models: function models() {
            return {
                checkoutCart: _index2.$CheckoutCartModel.instance(_angular.$rootScope.token).retrieve()
            };
        }
    },

    controller: function controller() {
        if (_angular.$location.path() === '/checkout') {
            _uiRouter.$state.go('checkout.review');
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.isMessengerBAIntegration = _integration.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
            _logger.$logger.info('IS_MESSENGER_BA_INTEGRATION: on Footer ' + this.isMessengerBAIntegration);
            this.token = _angular.$rootScope.token;
            this.locale = _squid.$locale;
            this.redirectiframe = _angular.$rootScope.partnerIntegration;
            this.redirectLightbox = true;
            this.escapeHatchInContext = !_angular.$rootScope.partnerIntegration;

            this.reviewUrl = 'checkout.review';
            this.isApp = _index3.$DeviceInfo.isApp();

            _angular.$document.bind('click', function (event) {
                _this.$broadcast('clickBody', event.target);
            });

            function rtl() {
                if ((0, _squid.$feature)('rtl')) {
                    _angular.$document.prop('documentElement').setAttribute('dir', _squid.$locale.metadata.directionality);
                }
            }

            this.$on('metadataChange', rtl);
            rtl();

            _fn.$fn.trigger();
        },
        populate: function populate() {
            if (this.pxp.purchaseProtectionAlt) {
                _squid.$config.features.DEFAULT.propValue = false;
            }

            function requiresRiskyLogin(state) {
                var auth = _index.$AuthModel.instance();
                return state.loginRequired && auth.remembered;
            }

            function displayRiskyLogin(oldState, newState, newParams) {

                if (!_integration.$integration.getConfig('ALLOW_AUTH')) {
                    _logger.$logger.info('login_overlay_suppressed');
                    return;
                }

                var isUserinitiated = oldState.template && !oldState.name.match(/checkout\.login/);

                if (isUserinitiated) {
                    var stateName = newState && newState.name;
                    var subFlowName = stateName && stateName.replace(/^.*\./, '');

                    if (subFlowName === 'sepaAgreement') {
                        _uiRouter.$state.go('checkout.review');
                    }

                    _angular.$rootScope.$broadcast('$insufficientPermission', {
                        oldState: oldState.name,
                        newState: newState.name,
                        pageOnOverlay: newState.pageOnOverlay
                    });
                } else {
                    var auth = _index.$AuthModel.instance();
                    var cause = newParams && newParams.message ? newParams.message : newState.name.replace(/^.*\./, '');
                    _logger.$logger.info('RISKY_LOGIN_TRANSITION_' + cause);
                    var showPasswordRecovery = (0, _squid.$feature)('pomaPasswordRecovery') && auth.password_less;
                    var transition = showPasswordRecovery ? 'checkout.createPassword' : 'checkout.login';
                    _uiRouter.$state.go(transition, {
                        targetPage: cause,
                        showNotYou: true
                    });
                }

                return false;
            }

            var cancelStateChangeEventListener = _angular.$rootScope.$on('$stateChangeStart', function (event, newState, newParams, oldState) {
                if (requiresRiskyLogin(newState)) {
                    event.preventDefault();
                    displayRiskyLogin(oldState, newState, newParams);
                }
            });

            this.$on('$destroy', cancelStateChangeEventListener);

            if (requiresRiskyLogin(_uiRouter.$state.current)) {
                displayRiskyLogin(_uiRouter.$state.current, _uiRouter.$state.current);
            }
        }
    }
});


_angular.$rootScope;

_angular.$document;

_angular.$location;

_squid.$Component;

_squid.$config;

_squid.$feature;

_squid.$pxp;

_squid.$locale;

_logger.$logger;

_uiRouter.$state;

_integration.$integration;

_index.$AuthModel;

_index2.$CheckoutCartModel;

_index3.$DeviceInfo;

_fn.$fn;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-checkout/directive.js
// module id = ./pages/xo-checkout/directive.js
// module chunks = 1